// export const SECURITY_AND_PRIVACY_STATEMENT = "https://studentgpa.incomegroupins.com.sg/static/media/Security_and_Policy.a31565d6.pdf"
export const SECURITY_AND_PRIVACY_STATEMENT = "/static/media/Security_and_Policy.a31565d6.pdf"
export const WEBSITE_TERMS_AND_CONDITIONS = "/static/media/Term_and_Condition.f637d3fe.pdf"
export const FAQ = "/static/media/GroupCare_FAQ.pdf"

export const PDPA_STATEMENT = "https://www.income.com.sg/privacy-policy"
export const ENQUIRY_EMAIL_MHC = "groupcare@mhcasiagroup.com"
export const ENQUIRY_EMAIL_SUBJECT = "Enquiry via GroupCare@Income Portal"
export const ENQUIRY_EMAIL_BODY_STRING = 'Please describe your enquiry briefly, we will response as soon as possible.';

// User Type constant
export const USER_TYPE = {
    CLIENT : "client",
    SYS_ADMIN : "sys-admin"
}

// User Roles constant
export const USER_ROLES = {
    ADMIN_ACCOUNT : "ADMIN_ACCOUNT",
    ADMIN_OPERATION : "ADMIN_OPERATION",
    ADMIN_CALL_CENTRE : "ADMIN_CALL_CENTRE",
    ADMIN_IT : "ADMIN_IT",
    ADMIN_CREATION: "ADMIN_CREATION"
}

// REST Error constant
export const REST_ERROR_CODE = {
    TOKEN_EXPIRED : "TOKEN_EXPIRED",
    ACCOUNT_TERMINATED : "ACCOUNT_TERMINATED",
    ACCOUNT_LOCKED : "ACCOUNT_LOCKED",
    ACCOUNT_SUSPENDED : "ACCOUNT_SUSPENDED"
}

// Claim status
export const CLAIM_STATUS = {
    PROCESSING : "PROCESSING",
    SUBMITTED : "SUBMITTED"
}

export const REWARDS_EXPIRED_DATE_FORMAT = ""

// Job result type
export const JOB_TYPE = {
    UPLOAD_USER_RESULT : "UPLOAD_USER_RESULT",
}

// User status
export const USER_STATUS = {
    NOT_REGISTERED : 101,
    INVITED : 102,
    REGISTERED : 100,
    LOCKED : 300,
    SUSPENDED : 301,
    TERMINATED : 401
}
